import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Line from './Line';

const List = styled.ul`
  padding-left: 0;
  margin-top: 0;
`;

class Lines extends Component {
  static propTypes = {
    lines: PropTypes.array
  };
  render() {
    const { lines } = this.props;
    return Array.isArray(lines) ? (
      <List>
        {lines.map((line, i) => {
          return <Line key={i} line={line} />;
        })}
      </List>
    ) : null;
  }
}

export default Lines;



// WEBPACK FOOTER //
// ./src/components/Steps/Lines.js